"use strict";
exports.__esModule = true;
var utils_1 = require("./utils");
exports["default"] = {
    please_select_time: function () { return "選んでください"; },
    start_time: function () { return "開始時間"; },
    end_time: function () { return "終了時間"; },
    hour: function () { return "時間"; },
    minute: function () { return "分"; },
    second: function () { return "秒"; },
    duration: {
        hour: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + "時間"; },
        minute: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + "分"; },
        second: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " 秒"; }
    },
    dayNamesMin: {
        Su: function () { return "日"; },
        Mo: function () { return "一"; },
        Tu: function () { return "二"; },
        We: function () { return "三"; },
        Th: function () { return "四"; },
        Fr: function () { return "五"; },
        Sa: function () { return "六"; }
    },
    weekNamesMin: {
        Su: function () { return "日曜日"; },
        Mo: function () { return "月曜日"; },
        Tu: function () { return "火曜日"; },
        We: function () { return "水曜日"; },
        Th: function () { return "木曜日"; },
        Fr: function () { return "金曜日"; },
        Sa: function () { return "土曜日"; }
    },
    monthNamesShort: {
        Jan: function () { return "1月"; },
        Feb: function () { return "2月"; },
        Mar: function () { return "3月"; },
        Apr: function () { return "4月"; },
        May: function () { return "5月"; },
        Jun: function () { return "6月"; },
        Jul: function () { return "7月"; },
        Aug: function () { return "8月"; },
        Sep: function () { return "9月"; },
        Oct: function () { return "10月"; },
        Nov: function () { return "11月"; },
        Dec: function () { return "12月"; }
    },
    ok: function () { return "確認する"; },
    now: function () { return "今"; },
    today: function () { return "今日"; },
    day: function () { return "日"; },
    weekHeader: function () { return "週"; },
    month: function () { return "月"; },
    year: function () { return "年"; },
    schedule: function () { return "スケジュール"; },
    allDay: function () { return "一日中"; },
    monthNames: {
        January: function () { return "1月"; },
        February: function () { return "2月"; },
        March: function () { return "3月"; },
        April: function () { return "4月"; },
        May: function () { return "5月"; },
        June: function () { return "6月"; },
        July: function () { return "7月"; },
        August: function () { return "8月"; },
        September: function () { return "9月"; },
        October: function () { return "10月"; },
        November: function () { return "11月"; },
        December: function () { return "12月"; }
    },
    startsWith: function () { return "から始まった"; },
    endsWith: function () { return "まで終わった"; },
    edit: function () { return "編集"; },
    confirm: function () { return "確認する"; },
    cancel: function () { return "キャンセル"; },
    collapse_sidebar: function () { return "サイドバーを折りたたむ"; },
    expand_sidebar: function () { return "サイドバーを展開する"; },
    expand: function () { return "隠す"; },
    collapse: function () { return "収める"; },
    no_data: function () { return "データなし"; },
    all_results_total: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "合計 " + d.count + " 件の結果"; },
    per_page_item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "ページあたり " + d.count + " 個のアイテム"; },
    item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 個のアイテム"; },
    go_to_page: function (_d) { var d = (0, utils_1.reqArgs)(["number"], _d); return "ページ " + d.number + " に移動します"; },
    select_all: function () { return "すべて選択"; },
    clear: function () { return "クリア"; },
    reset: function () { return "リセット"; },
    please_enter: function () { return "入力してください"; },
    input_placeholder: function (_d) { var d = (0, utils_1.reqArgs)(["context"], _d); return d.context + "を入力してください"; },
    phone_invalid: function () { return "不正な電話番号"; },
    phone: function () { return "電話番号"; },
    please_select: function () { return "選んでください"; },
    upload_file: function () { return "ファイルをアップロードする"; },
    upload_again: function () { return "再アップロード"; },
    uploading: function () { return "アップロード中"; },
    upload_successful: function () { return "アップロードに成功しました"; },
    upload_failed: function () { return "アップロード失敗"; },
    click_upload: function () { return "クリックしてアップロード"; },
    drag_upload: function () { return "このエリアにドラッグしてアップロードします"; },
    more_filters: function () { return "タグをもっと見る"; },
    empty: function () { return "クリア"; },
    more: function () { return "もっと"; },
    more_labels: function () { return "その他のフィルター"; },
    selected_items: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 個のアイテムが選択されました"; },
    password_placeholder: function () { return "パスワードを入力してください"; },
    preStep: function () { return "前に"; },
    nextStep: function () { return "次へ"; },
    formMessage: function (_d) { var d = (0, utils_1.reqArgs)(["content"], _d); return d.content + " エラー"; },
    upload_manager: {
        title: {
            in_progress: function () { return "アップロード中"; },
            task_cancal: function () { return "タスクがキャンセルされました"; },
            single: {
                succeeded: function () { return "アップロードに成功しました"; },
                failed: function () { return "アップロード失敗"; }
            },
            multiple: {
                all_succeeded: function () { return "すべて成功にアップロードされました"; },
                all_failed: function () { return "すべてのアップロードに失敗しました"; },
                partial_fail: function () { return "部分的なアップロードに失敗しました"; },
                succeed: function () { return "アップロードに成功しました"; },
                failed: function () { return "アップロード失敗"; }
            }
        },
        actions: {
            cancel: function () { return "アップロードをキャンセルする"; },
            cancel_all: function () { return "すべてキャンセルします"; },
            retry: function () { return "再アップロード"; },
            error_and_retry: function () { return "ネットワークエラー、再アップロード"; },
            retry_all: function () { return "すべて再試行してください"; }
        },
        messages: {
            cancelled: function () { return "アップロードがキャンセルされました"; },
            estimated_upload_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "推定アップロード時間 " + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 個のファイルがアップロードされています"; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 個のファイルをアップロードできませんでした"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 個のファイルがアップロードされました"; },
            has_identical_files: function () { return "ディレクトリ内に同じ内容のファイルが検出されました"; }
        }
    },
    emptyMessage: function () { return "オプションなし"; },
    emptyMatchedMessage: function () { return "一致するデータがありません"; },
    emptyFilterMessage: function () { return "クエリ結果が空です"; },
    pleaseEnterSearchContent: function () { return "お問い合わせ内容を入力してください"; },
    region: {
        China: function () { return "中国"; },
        HongKong: function () { return "香港"; },
        Macao: function () { return "マカオ"; },
        Taiwan: function () { return "台湾"; },
        America: function () { return "アメリカ合衆国"; },
        Australia: function () { return "オーストラリア"; },
        Singapore: function () { return "シンガポール"; }
    },
    download_manager: {
        title: {
            in_progress: function () { return "下载中"; },
            task_cancal: function () { return "任务取消"; },
            single: {
                succeeded: function () { return "下载成功"; },
                failed: function () { return "下载失败"; }
            },
            multiple: {
                all_succeeded: function () { return "全部下载成功"; },
                all_failed: function () { return "全部下载失败"; },
                partial_fail: function () { return "部分下载失败"; },
                succeed: function () { return "下载成功"; },
                failed: function () { return "下载失败"; }
            }
        },
        actions: {
            cancel: function () { return "取消下载"; },
            cancel_all: function () { return "全部取消"; },
            retry: function () { return "重新下载"; },
            error_and_retry: function () { return "网络错误，重新下载"; },
            retry_all: function () { return "全部重试"; }
        },
        messages: {
            pending: function () { return "等待下载..."; },
            cancelled: function () { return "下载取消"; },
            estimated_download_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "预计下载用时" + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件正在下载"; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件下载失败"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "已下载 " + d.count + " 个文件"; },
            has_identical_files: function () { return "检测到目录中含相同内容文件"; }
        }
    }
};
